<ion-card (click)="assetScanLookup()">
  <ion-card-header class="ion-text-center">
    <ion-card-title>Scan Asset Lookup</ion-card-title>
    <i class="far fa-barcode-read facility-scan-icon facility-icon facility-scan-lookup-icon"></i>
  </ion-card-header>
  <ion-card-content>
    <ion-card-subtitle class="ion-text-center">Quickly locate scanned Assets</ion-card-subtitle>
  </ion-card-content>
</ion-card>